import { EquipamentoRdService } from 'src/app/services/equipamento-rd.service';
import { RdService } from 'src/app/services/rd.service';
import { Component, OnInit, AfterContentInit } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { ModeloRdService } from 'src/app/services/modelo-rd.service';
import { DatePipe } from '@angular/common';
import { SCAMP_API_RPT } from 'src/environments/environment';

@Component({
  selector: 'app-emissao-rd',
  templateUrl: './emissao-rd.component.html',
  styleUrls: ['./emissao-rd.component.scss']
})

//202003221205
export class EmissaoRdComponent implements OnInit, AfterContentInit {


  public cadastrados: any[] = [];
  public modelosRD: any[] = [];
  public rDEquipamentos: any[] = [];
  public fieldsDetEquipamento: string[] = ["manhaNormal", "tardeNormal", "manhaEspecial", "tardeEspecial", "diaria", "horas"]

  public form: FormGroup = null;
  public id = 0; // representa o id do modelo. Se 0 novo cadastro, Se > 0 editando
  public isProcessing = false;
  public isEditing = false;
  public imprimindoRD = false;
  public imprimindoRDId = 0;

  public validaDataInicio: string = '';
  public validaDataTermino: string = '';
  public rds: any[] = [];
  public validaSituacaoClimatica: string = '';
  public validaDataModeloRDUnico: string = '';



  public validaDataRDExistente: string = '';
  public validaRDIdExistente: string = '';
  //rDIdExistente
  public rdExistente: any = null;



  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private modeloRDService: ModeloRdService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private rdService: RdService,
    private equipamentoRDService: EquipamentoRdService,
    private datePipe: DatePipe,


  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('emitir-rd');
  }

  ngOnInit() {
    //this.getAll(); // carrega lista de já cadastrados
    this.getAllModelosRD();
    this.getAllEquipamentosRDWithDetPromise(0);
    this.resetForm(); // instancia o formulário utilizado (formGroup)

  }

  isUniqueDataRdModeloIdAsync = async () => {

    const data = this.form.value;
    this.validaDataModeloRDUnico = '';

    if (data.rDData && data.rDModeloId) {
      // Verifica se Data + Modelo já existem
      const response = await this.rdService.isUniqueDataRdModeloId(data.rDData, data.rDModeloId, data.id).toPromise();

      if (response == false) {
        this.validaDataModeloRDUnico = "Este Modelo RD para esta data já está em uso";
      }

      return response;
    } else {

      return false;
    }

  }


  public async getNextRdNumeroSeq() {

    if (await this.isUniqueDataRdModeloIdAsync()) {
      const data = this.form.value;
      this.validaDataModeloRDUnico = '';

      if (data.rDData && data.rDModeloId) {

        /*    this.rdService.getNextRdNumeroSeq(data.rDData).subscribe((response) => {
             this.form.get('rDNumeroSeq').setValue(Number(response));
           }); */


        this.rdService.getNextRdNumeroSeqPromise(data.rDData)
          .then(response => response.json())
          .then(json => this.form.get('rDNumeroSeq').setValue(Number(json)));




      }
    }

  }


  public getAllModelosRD() {
    /* this.modeloRDService.getAll().subscribe((response: any) => {
      this.modelosRD = response;
    }); */

    this.modeloRDService.getAllPromise()
    .then(response => response.json())
    .then(json => this.modelosRD = json);
    }

  public getAllEquipamentosRDWithDet(rdId: number, reuso: boolean = false) {
    this.isProcessing = true;
    this.rDEquipamentos = [];
    this.equipamentoRDService.getAllWithDet(rdId).subscribe(
      (response) => {
        this.rDEquipamentos = response;
        this.rDEquipamentos.forEach(x => {
          x.rdDetsEquipamento[0].hasAnyData = false;
        });

        if (rdId > 0) {

          this.rDEquipamentos.forEach(rd => {

            this.fieldsDetEquipamento.forEach(f =>
              rd.rdDetsEquipamento[0].hasAnyData =
              (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0][f] !== null)
            );

            rd.rdDetsEquipamento[0].hasAnyData =
              (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0].observacao !== null)

          });
        }


        if (reuso) {
          this.rDEquipamentos.forEach(rd => {
            rd.rdDetsEquipamento.forEach(det => {
              det.rdId = 0;
              det.id = 0;
            })
          });

        }


        this.isProcessing = false;
      },
      (error) => {
        this.isProcessing = false;
        this.showError(error);
      }
    )
  }


  public getAllEquipamentosRDWithDetPromise(rdId: number, reuso: boolean = false) {
    this.isProcessing = true;
    this.rDEquipamentos = [];
    this.equipamentoRDService.getAllWithDetPromise(rdId)
    .then(response => response.json())
    .then (json => 
      {
        this.rDEquipamentos = json;
        this.rDEquipamentos.forEach(x => {
          x.rdDetsEquipamento[0].hasAnyData = false;
        });

        if (rdId > 0) {

          this.rDEquipamentos.forEach(rd => {

            this.fieldsDetEquipamento.forEach(f =>
              rd.rdDetsEquipamento[0].hasAnyData =
              (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0][f] !== null)
            );

            rd.rdDetsEquipamento[0].hasAnyData =
              (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0].observacao !== null)

          });
        }
        if (reuso) {
          this.rDEquipamentos.forEach(rd => {
            rd.rdDetsEquipamento.forEach(det => {
              det.rdId = 0;
              det.id = 0;
            })
          });

        }

        this.isProcessing = false;
      }
      
    )
    .catch((error) => {
      this.isProcessing = false;
      this.showError(error);
    })
  }

 



  public changeSituacaoClimatica(situacao: string) {
    this.form.get('condicaoClima').setValue(situacao);
    this.validaSituacaoClimatica = '';
  }
  /*  public getAll(): void {
    
   } */

  public resetForm(): void {
    this.form = this.formBuilder.group(
      {
        id: [0],
        rDNumeroSeq: [null],
        condicaoClima: [null],
        rDData: [this.datePipe.transform(new Date(), 'yyyy-MM-dd'), [Validators.required]],
        rDModeloId: [null, [Validators.required]],
        obsContratada: [null],
        obsFiscalizacao: [null],
        rDDetEquipamentos: [[]],

      });

    this.isEditing = false;



  }

  public reset(): void {

    this.isProcessing = false;
    this.isEditing = false;
    this.validaSituacaoClimatica = '';
    this.validaDataInicio = '';
    this.validaDataTermino = '';

    this.validaDataRDExistente = '';
    this.validaRDIdExistente = '';
    this.validaDataModeloRDUnico = ''



    this.resetForm();
    this.getAllEquipamentosRDWithDet(0);
  }



  public async submit() {

    if (this.validForm() && await this.isUniqueDataRdModeloIdAsync()) {

      let detEquipamentos: any[] = [];

      this.rDEquipamentos.forEach(x => {
        if (x.rdDetsEquipamento[0].id > 0 || x.rdDetsEquipamento[0].hasAnyData) {
          detEquipamentos.push(x.rdDetsEquipamento[0]);
        }
      })

      this.form.get('rDDetEquipamentos').setValue(detEquipamentos);

      this.rdService.add(this.form.value).subscribe(

        (response: any) => {

          if (response.success == true) {
            this.toastr.success(response.message);
          } else {
            this.toastr.warning(response.message);
          }
          this.reset();
          //this.getAll();
        },
        (error: any) => {
          this.showError(error);
        }
      );
    }
  }

  validForm = () => {

    let valid: boolean = true;

    this.validaSituacaoClimatica = '';

    if (!this.form.get('condicaoClima').value) {
      this.validaSituacaoClimatica = 'Selecione uma situação climática';
      valid = false;
    }

    return valid;

  }

  public changeRDDetEquipamento(equipamentoId, field, value) {

    const rdEquipamento = this.rDEquipamentos.find(x => x.id == equipamentoId);

    if (rdEquipamento) {
      rdEquipamento.rdDetsEquipamento[0][field] = value ? value : null;

      if (rdEquipamento.rdDetsEquipamento[0][field] != null) {
        rdEquipamento.rdDetsEquipamento[0].hasAnyData = true;
      } else {
        rdEquipamento.rdDetsEquipamento[0].hasAnyData = false;
        this.fieldsDetEquipamento.forEach(f =>
          rdEquipamento.rdDetsEquipamento[0].hasAnyData =
          (rdEquipamento.rdDetsEquipamento[0].hasAnyData || rdEquipamento.rdDetsEquipamento[0][f] !== null)
        );

        rdEquipamento.rdDetsEquipamento[0].hasAnyData =
          (rdEquipamento.rdDetsEquipamento[0].hasAnyData || rdEquipamento.rdDetsEquipamento[0].observacao !== null)
      }
    }
  }

  public showError(error: any) {

    this.form.get('nome').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }


  public showModalPesquisarRD(modal: any) {
    this.rds = [];
    this.modalService.open(modal, { windowClass: 'xlModal', backdrop: 'static' });
  }

  public showModalReuseRD(modal: any) {
    this.rdExistente = null;
    this.modalService.open(modal, { windowClass: 'lgModal', backdrop: 'static' });
  }


  public search() {

    this.validaDataInicio = '';
    this.validaDataTermino = '';



    let inputDataInicio = (document.getElementById('inputDataInicio') as HTMLInputElement).value;
    let inputDataTermino = (document.getElementById('inputDataTermino') as HTMLInputElement).value;

    if (inputDataInicio == '') {
      this.validaDataInicio = 'Informe uma data válida';
    }

    if (inputDataTermino == '') {
      this.validaDataTermino = 'Informe uma data válida';
    }

    if (inputDataInicio == '' || inputDataTermino == '') {
      return;
    }

    let dataIntervaloInicio = new Date(new Date(inputDataInicio).getTime() + 3 * 60 * 60 * 1000); // correção GMT
    let dataIntervaloTermino = new Date(new Date(inputDataTermino).getTime() + 3 * 60 * 60 * 1000); // correção GMT

    if (dataIntervaloInicio.getTime() > dataIntervaloTermino.getTime()) {

      const dataTemp = inputDataInicio;

      (document.getElementById('inputDataInicio') as HTMLInputElement).value = inputDataTermino;
      (document.getElementById('inputDataTermino') as HTMLInputElement).value = inputDataInicio;

      inputDataInicio = inputDataTermino;
      inputDataTermino = dataTemp;

    }

    this.rds = [];

/*     this.rdService.getByIntervalAsync(inputDataInicio, inputDataTermino).subscribe(
      (response) => {
        this.rds = response;
        if (this.rds.length == 0) {
          this.toastr.warning("A pesquisa não retornou resulados com os parâmetros informados")
        }
      }
    ) */


    this.rdService.getByIntervalPromise(inputDataInicio, inputDataTermino)
      .then(response => response.json())
      .then(json => {
        this.rds = json;
        if (this.rds.length == 0) {
          this.toastr.warning("A pesquisa não retornou resulados com os parâmetros informados")
        }
      })
      .catch(this.showError)

  }


  public searchRDExistente() {

    this.validaDataRDExistente = '';
    this.validaRDIdExistente = '';

    let inputData = (document.getElementById('inputDataRDExistente') as HTMLInputElement).value;
    let rdModeloIdExistente = (document.getElementById('rdModeloIdExistente') as HTMLInputElement).value;


    if (inputData == '') {
      this.validaDataRDExistente = 'Informe uma data válida';
    }

    if (rdModeloIdExistente == '') {
      this.validaRDIdExistente = 'Selecione um modelo RD';
    }

    if (inputData == '' || !rdModeloIdExistente) {
      return;
    }

    this.rdExistente = null;

    this.rdService.getByDataAndModeloRD(inputData, rdModeloIdExistente).subscribe(
      (response) => {
        this.rdExistente = response;
        if (!this.rdExistente) {
          this.toastr.warning("A pesquisa não retornou resulados com os parâmetros informados")
        }
      }
    )
  }

  public getById(rdId: number, reuso: boolean = false) {

    this.reset();
    this.isProcessing = true;

    this.rdService.getById(rdId).subscribe(

      (response: any) => {

        this.form.patchValue({
          id: response.id,
          rDNumeroSeq: response.rdNumeroSeq,
          condicaoClima: response.condicaoClima,
          rDData: response.rdData.split('T')[0],
          rDModeloId: response.rdModeloId,
          obsContratada: response.obsContratada,
          obsFiscalizacao: response.obsFiscalizacao,
          rDDetEquipamentos: [],
        });


        this.getAllEquipamentosRDWithDet(rdId, reuso);


        this.isEditing = true;
        this.isProcessing = false;
        this.modalService.dismissAll();

        if (reuso) {
          this.form.get('id').setValue(0);
          this.isEditing = false;
        }

      },
      (error: any) => {
        this.showError(error);
      },
    );
  }


  reuseRD() {
    if (this.rdExistente != null) {
      //this.reset();
      this.getById(this.rdExistente.id, true);
    }
  }

  imprimirRD(rdId: number) {

    if (rdId == 0) {
      return;
    }

    this.imprimindoRD = true;
    this.imprimindoRDId = rdId;


    this.rdService.imprimirRD(rdId).subscribe((response) => {

      if (response.success === true) {

        if (response.nenhumResultado === false) {

          window.open(
            `${SCAMP_API_RPT.root}${response.pathRpt}`,
            '_blank',
            'width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no'
          );
        } else {
          this.toastr.warning(response.msgErro);
        }
      } else {
        this.toastr.error(response.msgErro);

      }
      this.imprimindoRD = false;
      this.imprimindoRDId = 0;

    },
      (err: any) => {
        this.toastr.error('Não foi possível se conectar ao servidor de relatórios', 'Erro de Conexão');
        this.imprimindoRD = false;
        this.imprimindoRDId = 0;
      });

  }

}

